export class OnlineStateService {
    get isOnline$() {
        return this._isOnline;
    }

    private _isOnline = new Rx.BehaviorSubject(navigator.onLine);

    constructor() {
        const updateOnlineStatus = () => this._isOnline.onNext(navigator.onLine);
        window.addEventListener('online', updateOnlineStatus);
        window.addEventListener('offline', updateOnlineStatus);
    }
}

angular.module('tradersyard').service('OnlineStateService', OnlineStateService);
